import React from "react";
import ArrowRight from "./arrowRight";
import useWindowWidth from "./useWindowWidth";
import { useNavigate } from "react-router-dom";

const Card = (props) => {
    const navigate = useNavigate();
    const width = useWindowWidth(435);

    return (
        <>
            <div className="card">
                <div className="svg-container">
                    { props.left }
                    <ArrowRight />
                    { props.right }
                </div>
                <div className="middle-title" style={{ fontSize: width ? "20px" : "" }}>
                    { props.title }
                </div>
                <div className="card-button" onClick={() => {
                    navigate("/sign-up")
                }}>
                    { props.button }
                </div>
                {
                    props.soon && (
                        <div className="soon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1"/>
                            </svg>
                            Soon
                        </div>
                    )
                }
            </div>
        </>
    );
}

export default Card;